import React from 'react';
import { Link } from 'react-router-dom';
import { NavLink} from "react-router-dom"; 
 
const SidebarComp = ({ allUserRolePermissionData }) => { 

  const removeDuplicatesByName = (arr) => {
    const uniqueNames = new Set();
    return arr?.filter((item) => {
      if (!uniqueNames.has(item.menuData.menu_name)) {
        uniqueNames.add(item.menuData.menu_name);
        return true;
      }
      return false;
    });
  };
  
   let uniqueData = removeDuplicatesByName(allUserRolePermissionData); 

 
  return (
    <div className="sidebar">
      <ul  className="h-100">
        {uniqueData && uniqueData.map((item) => (
            <React.Fragment key={item?.menuData?.id}>
              <li>
                <NavLink to={item?.menuData?.url_path}>
                  <i className={item?.menuData?.icon}></i>&nbsp;
                  <span>{item?.menuData?.menu_name}</span>
                </NavLink>
              </li>
            </React.Fragment>
          ))}
      </ul>
    </div>
  );
}; 
export default SidebarComp;
